import {
  CHANNELS_MAP_INVOKE_TYPE,
  CHANNELS_MAP_ON_TYPE,
  STORE_TYPES,
} from '@/main/type';
import { IS_IN_ELECTRON } from '@/utils/global';

export class ElectronSDK {
  static getStore(key: keyof STORE_TYPES): STORE_TYPES[keyof STORE_TYPES] {
    if (IS_IN_ELECTRON) {
      return window.electron.store.get(key);
    }
    return window.localStorage.getItem(key) as STORE_TYPES[keyof STORE_TYPES];
  }

  static setStore(
    key: keyof STORE_TYPES,
    value: STORE_TYPES[keyof STORE_TYPES],
  ) {
    if (IS_IN_ELECTRON) {
      return window.electron.store.set(key, value);
    }
    return window.localStorage.setItem(key, value);
  }

  static ipcRenderer = {
    // on: <T extends keyof CHANNELS_MAP_ON_TYPE>(
    //   key: T,
    //   value: CHANNELS_MAP_ON_TYPE[T],
    // ) => {
    //   if (!IS_IN_ELECTRON) {
    //     return new Error('SDK is not ready');
    //   }
    //   return window.electron.ipcRenderer.on(key, value);
    // },
    sendMessage: <T extends keyof CHANNELS_MAP_ON_TYPE>(
      key: T,
      value: CHANNELS_MAP_ON_TYPE[T],
    ) => {
      if (!IS_IN_ELECTRON) {
        throw new Error('SDK is not ready');
      }
      return window.electron.ipcRenderer.sendMessage(key, value);
    },
    invoke: async <T extends keyof CHANNELS_MAP_INVOKE_TYPE>(
      key: T,
      value: CHANNELS_MAP_INVOKE_TYPE[T],
    ) => {
      if (!IS_IN_ELECTRON) {
        throw new Error('SDK is not ready');
      }
      return window.electron.ipcRenderer.invoke(key, value);
    },
  };

  static shell = {
    openExternal: (link: string) => {
      if (!IS_IN_ELECTRON) {
        throw new Error('SDK is not ready');
      }
      return window.electron.shell.openExternal(link);
    },
  };
}
export const electronSDK = new ElectronSDK();
